module.exports = __webpack_public_path__ + "img/qcks_ztb_main.879fed61.jpg";